/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class CHILENode extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "CHILENode";
}

const servicePlugin = makeServicePlugin({
  Model: CHILENode,
  service: feathersClient.service("data-services/chile/nodes"),
  idField: "Node ID",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
